import { render, staticRenderFns } from "./DestinationGuide.vue?vue&type=template&id=24b1d22c&scoped=true"
import script from "./DestinationGuide.vue?vue&type=script&lang=js"
export * from "./DestinationGuide.vue?vue&type=script&lang=js"
import style0 from "./DestinationGuide.vue?vue&type=style&index=0&id=24b1d22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b1d22c",
  null
  
)

export default component.exports